import React from 'react';
import Navbar from "../Component/Navbar";
import Homerest from '../Component/Homerest';

const  Home=()=>{
    return( 
        <>

        <Navbar/>
        <Homerest />
        </>
    )
}
export default Home;